module.exports = __webpack_public_path__ + "img/finger/finger.png";


//////////////////
// WEBPACK FOOTER
// ./img/finger/finger.png
// module id = 64
// module chunks = 3